// Keep this literal aligned with package.json. The release guard and tests fail
// closed on drift without bundling the full package manifest into the app.
export const APP_VERSION = "0.6.12";
